import { gql, useQuery } from '@apollo/client';

export const CHECK_IF_PROJECT_NUMBER_EXISTS = gql`
  query ($projectNumber: String!) {
    checkIfProjectNumberAlreadyExists(projectNumber: $projectNumber)
  }
`;

export const useCheckIfProjectNumberAlreadyExists = (projectNumber?: string) => {
  const { data, loading } = useQuery(CHECK_IF_PROJECT_NUMBER_EXISTS, {
    variables: { projectNumber },
    skip: !projectNumber,
    fetchPolicy: 'no-cache',
  });

  const projectNumberExists = !!data?.checkIfProjectNumberAlreadyExists;

  return { projectNumberExists, loading };
};
